<template>
  <div class="shang">
  			  <div class="shang_head">
  				  <el-form :inline="true" class="demo-form-inline">
  				    <el-form-item label="活动名称">
  				      <el-input v-model="searchCom.post.name" size="small" placeholder="请输入活动名称"></el-input>
  				    </el-form-item>
  				    <el-form-item>
  				      <el-button @click="getGoodsList()" type="primary" class="base_but_style" >查询</el-button>
  				    </el-form-item>
  				  </el-form>
  			  </div>
  			<!--  <div class="shang_tab">
  				  <div @click="searchCom.post.listType='all';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='all'?'shang_tab_active':'']" class="shang_tab_item">全部</div>
  				  <div @click="searchCom.post.listType='on_sale';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='on_sale'?'shang_tab_active':'']" class="shang_tab_item">出售中</div>
  				  <div @click="searchCom.post.listType='off_sale';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='off_sale'?'shang_tab_active':'']" class="shang_tab_item">已下架</div>
  				  <div @click="searchCom.post.listType='sold_out';searchCom.post.page=1;getGoodsList()" :class="[searchCom.post.listType=='sold_out'?'shang_tab_active':'']" class="shang_tab_item">已售罄</div>
  			  </div> -->
  			  <div class="shang_box">
  				  <div v-if="searchCom.table.length<=0" style="width: 100%;padding: 40px 0;color: #999;text-align: center;">暂无数据</div>
  				  <div @click="selectGood(index)" :class="[item.select?'shang_box_active':'']" v-for="(item,index) in searchCom.table" :key="index" class="shang_box_item">
  					  <i v-if="item.select" class="shang_box_radio el-icon-success"></i>
  					  <img class="shang_box_img" :src="item.image" alt="" />
  						<div class="shang_box_flex ">
  							<div class="shang_box_title " style="margin-bottom: 0;">{{item.name || ''}}</div>
  							<div class=" ">
  								<div class="shang_box_num" style="font-size: 12px;">开始：{{item.start_time.substring(0,13) || ''}}</div>
  								<div class="shang_box_num" style="font-size: 12px;">结束：{{item.end_time.substring(0,13) || ''}}</div>
  							</div>
  						</div>
  				  </div>
  			  </div>
  			  <div v-if="searchCom.table.length>0" style="text-align: center;">
  				  <el-pagination
  				    background @current-change="changepageGood"
  				  				:page-size="12"
  				    layout="prev, pager, next" :total="searchCom.total">
  				  </el-pagination>
  				  
  			  </div>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import draggable from "vuedraggable";
export default {
  name: "classifylist",
  components: {
    draggable,
  },
  data() {
    return {
      // 商品
      searchCom: {
        post: {
          page: 1,
          limit: 12,
          name: ""
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "ID", prop: "goods_id", width: 70 },
          { label: "商品信息", prop: "goods_info", width: 310 },
          { label: "商品价格", prop: "goods_price_min", width: 120 },
          { label: "库存总量", prop: "stock_total" },
          { label: "状态", prop: "status", width: 110 },
        ],
        table: [],
      },
    };
  },
  created() {
    this.getGoodsList();
  },
  methods: {
	  changepageGood(e){
	  		this.searchCom.post.page = e
	  		this.getGoodsList()
	  },
	  selectGood(index){
	  		  this.searchCom.table.map(res=>{
	  			  res.select= false
	  			  return res
	  		  })
	  		this.searchCom.table[index]['select'] = true
			this.$emit("getItem", {
				id:this.searchCom.table[index].id,
				name:this.searchCom.table[index].name
			})
	  		// this.curItem = {
	  		//         id: "commidy",
	  		//         path: this.searchCom.table[index].goods_id,
	  		//         title: "商品详情-" + this.searchCom.table[index].goods_name,
	  		//       };
	  },
    // 商品列表
        getGoodsList() {
          let _this = this;
          _this.searchCom.loading = true;
          _this.axios
            .get("/api/weishop/admin/plugin/vote/activity/index", {
              params: {
                ..._this.searchCom.post,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                _this.searchCom.table = res.data.data.map((item) => {
                  return {
                    ...item,
    				select:false
                  };
                });
                _this.searchCom.total = res.data.total;
              } else {
                eltips(res.msg, "error");
              }
              _this.searchCom.loading = false;
            });
        },
        // 商品获取到的数据
        tableSelectionChange(e) {
          this.curItem = {
            id: "commidy",
            path: e.goods_id,
            title: "商品详情-" + e.goods_name,
          };
        },
  },
};
</script>

<style scoped lang="less">
.shang{
	&_head{
		display: flex;
	}
	&_tab{
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ededed;
		&_item{
			font-size: 14px;
			position: relative;
			margin: 0 20px;
			height: 40px;
			line-height: 40px;
			cursor: pointer;
		}
		&_active{
			&::after{
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				height: 2px ;
				width: 100%;
				background-color: #006aff;
			}
			
		}
	}
	&_box{
		&_item{
			display:inline-flex;
			border-radius: 5px;
			border: 1px solid #ededed;
			padding: 10px;
			width: calc(33.33% - 10px);
			margin: 10px 5px;
			cursor: pointer;
			position: relative;
		}
		&_active{
			border: 1px solid #006aff;
			
		}
		&_radio{
			position: absolute;
			right: -4px;
			bottom: -4px;
			color: #006aff;
		}
		&_img{
			width: 60px;
			height: 60px;
			display: block;
			margin-right: 10px;
			border-radius: 5px;
		}
		&_flex{
			flex: 1;
			overflow: hidden;
			white-space: nowrap;//禁止换行
			text-overflow: ellipsis;//当对象内文本溢出时显示省略标记
		}
		&_title{
			font-size: 16px;
			margin-bottom: 10px;
			overflow: hidden;
			white-space: nowrap;//禁止换行
			text-overflow: ellipsis;//当对象内文本溢出时显示省略标记
		}
		&_price{
			color: #006aff;
		}
		&_data{
			display: flex;
			align-items: center;
			justify-content: space-between;
			flex: 1;
		}
		&_num{
			color: #999;
		}
	}
}
</style>
